"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.ReceiptHeaderContainer=exports.EmailHeaderContainer=exports.BannerTextContainer=exports.BannerHeader=exports.BackButtonContainerForSelectedReceipt=exports.BackButtonContainer=void 0;const BannerHeader=exports.BannerHeader=_styledComponents.default.div`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  background-color: #fff;
  padding: 20px 0px 24px 0px;
  top: 0px;
  width: 100%;
`,BackButtonContainer=exports.BackButtonContainer=_styledComponents.default.div`
  display: flex;
  align-self: center;
`,BackButtonContainerForSelectedReceipt=exports.BackButtonContainerForSelectedReceipt=_styledComponents.default.div`
  display: flex;
  align-self: center;
  width: 33.33vw;
`,BannerTextContainer=exports.BannerTextContainer=_styledComponents.default.div`
  margin-left: auto;
  margin-right: auto;
  .banner {
    font-size: 30px;
  }
`,ReceiptHeaderContainer=exports.ReceiptHeaderContainer=_styledComponents.default.div`
  width:85vw;
  .banner {
    font-size: 30px;
  }
`,EmailHeaderContainer=exports.EmailHeaderContainer=_styledComponents.default.div`
  .banner{
    font-size: 30px;
  }
`;